import {
  Box,
  Container,
  containerClasses,
  styled,
  Typography,
  typographyClasses,
} from '@mui/material';
import { config } from 'public/styles/config';
import { useTranslation } from 'react-i18next';
import { UploadCertificateForm } from 'public/components/certificates/forms/upload-certificate-form/upload-certificate-form';

export const CertificateUpload = () => {
  const { t } = useTranslation('web-common');

  return (
    <StyledContainer>
      <StyledHeader>
        <StyledTitle>{t('upload-certificate-screen.screen-title')}</StyledTitle>
      </StyledHeader>
      <UploadCertificateForm />
    </StyledContainer>
  );
};

const StyledTitle = styled(Typography)(({ theme }) => ({
  [`&.${typographyClasses.root}`]: {
    fontSize: theme.typography.pxToRem(36),
    fontWeight: 700,
    color: theme.palette.lwBlack[100],
    fontVariationSettings: '"wght" 700',
    lineHeight: '40px',
  },
}));

const StyledHeader = styled(Box)(({ theme }) => ({
  display: 'flex',
  flexDirection: 'column',
  alignItems: 'center',
  justifyContent: 'center',
  textAlign: 'center',
  gap: theme.spacing(3),
  marginBottom: theme.spacing(8),
}));

const StyledContainer = styled(Container)({
  [`&.${containerClasses.root}`]: {
    display: 'flex',
    flexDirection: 'column',
    alignItems: 'center',
    justifyContent: 'center',
    minHeight: '100vh',

    '& *': {
      fontFamily: config.fontFamily,
    },
  },
});
